export default defineAppConfig({
  ui: {
    colors: {
      primary: 'ultramarine',
      neutral: 'slate',
    },
  },
})
